var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.191 4.299a1.054 1.054 0 1 0-1.49-1.49L10 8.509l-5.701-5.7a1.054 1.054 0 1 0-1.49 1.49L8.509 10l-5.7 5.701a1.054 1.054 0 0 0 1.49 1.49l5.701-5.7 5.701 5.7a1.054 1.054 0 0 0 1.49-1.49L11.491 10l5.7-5.701Z",
    fill: "currentColor"
  })));
};
export default SvgClose;